import React from 'react';

export default function Flashcard({ front, back, flipped, onFlip, darkMode }) {
  return (
    <div
      onClick={onFlip}
      style={{
        cursor: 'pointer',
        border: '1px solid #ccc',
        padding: '20px',
        margin: '10px 0',
        textAlign: 'center',
        borderRadius: '8px',
        minHeight: '80px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: flipped
          ? darkMode
            ? '#333'      // back side dark
            : '#f0f8ff'  // back side light
          : darkMode
          ? '#1e1e1e'   // front side dark
          : '#fff',     // front side light
        color: darkMode ? '#ffffff' : '#000',  // brighter text for readability
        transition: 'background-color 0.3s, color 0.3s',
        fontSize: '1.2em'
      }}
    >
      {flipped ? back : front}
    </div>
  );
}
